<app-ice-pill cursor="default" type="info" [isInteractive]="false" [ngClass]="pillSize()">{{ pillText() }}</app-ice-pill>
<ng-content />
